/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { ColDef, TableSetting, TableStd, ToolbarSetting } from 'app/components'
import React from 'react'
import { AsessFilterDto, SeasonDto, SelfAssessService, SystemDateDisplayFormat, SystemDateSaveFormat, SystemTimeFormat } from 'app/modules/core'
import { useNavigate } from 'react-router-dom'
import { KTSVG } from '_metronic/helpers'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from 'setup'
import moment from 'moment'
import clsx from 'clsx'
import { Popover, PopoverBody, PopoverHeader } from 'react-bootstrap'
import { PopOver } from 'app/components/popOver/popOver'


const SelfAssessPage: FC = () => {
  const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
  const navigate = useNavigate()
  const [reload, setReload] = React.useState<{}>()
  const [data, setData] = useState<string[][]>([])
  const [footData, setFootData] = useState<string[][]>([])


  const WarpItemRender = (arrItem:string[][],index:number) => {
    
    let model = JSON.parse(arrItem[index].toString());
    return <>
      <span className={clsx('d-flex flex-row', { 'text-primary fw-bolder': model.point.toString() !== '0' })}>
        {model.point}
        {model.isEdit && <PopOver className='ms-2' title='Remark' conent={model.remark}>
          <i className="fa-solid fa-circle-info" style={{ color: "#fe0101" }}></i>
        </PopOver>}
      </span>

    </>
  }

  const columnDef: ColDef<string[][]>[] = [
    {
      label: 'เดือน',
      width: "20%",
      renderItem: ({ item, index }) => item[index],
    },
    {
      label: 'มาสาย',
      width: "15%",
      renderItem: ({ item, index }) =>  WarpItemRender(item,1),
    },
    {
      label: 'ลา',
      width: "15%",
      renderItem: ({ item, index }) => WarpItemRender(item,2),
    },
    {
      label: 'สถิติ',
      width: "15%",
      renderItem: ({ item, index }) => WarpItemRender(item,3),
    },
    {
      label: 'แฟ้ม',
      width: "15%",
      renderItem: ({ item, index }) => WarpItemRender(item,4),
    },
    {
      label: '',
      renderItem: ({ item }) => <>
        <div className='text-center'>
          <button
            type='button'
            onClick={(e) => {
              const key = tableSetting.primaryKey(item)
              navigate('/selfAssessDetail/' + key[0])
            }
            }
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
          >
            <KTSVG
              path='/media/icons/duotune/art/art005.svg'
              className='svg-icon-3'
            />
          </button>


        </div>
      </>,
    },
  ]

  const footerDef: ColDef<string[][]>[] = [
    {
      label: 'เดือน',
      renderItem: ({ item, index }) => item[index],
    },
    {
      label: 'มาสาย',
      renderItem: ({ item, index }) => item[index],
    },
    {
      label: 'ลา',
      renderItem: ({ item, index }) => item[index],
    },
    {
      label: 'สถิติ',
      renderItem: ({ item, index }) => item[index],
    },
    {
      label: 'แฟ้ม',
      renderItem: ({ item, index }) => item[index],
    },
    {
      label: '',
      renderItem: () => <></>,
    },
  ]

  const tableSetting: TableSetting<string[][]> = {
    showColAction: false,
    primaryKey: (item: string[][]) => item,
  }
  const toolbarSetting: ToolbarSetting = {
    showBtnAdd: false,
    showFilter: false,
    showSearch: false,
    btnAddText: 'ประเมินตัวเอง',
    searchTextValue: '',
    onBtnAddClick: () => navigate('/selfAssessDetail/new')
  }

  useEffect(() => {
    const load = () => {
      if (lastSeason) {
        SelfAssessService.Search({
          startDate: lastSeason.periodStart,
          endDate: lastSeason.periodEnd,
        }).then((result) => {
          const row = result.data.result
          setData(row.rows)
          setFootData(row.footers)
        })
      }
    }
    load()
  }, [lastSeason, reload])

  return (
    <>
      <PageTitle breadcrumbs={[]}></PageTitle>
      <div className={`card mb-5 mb-xl-8`}>
        <div className='card-header cursor-pointer'>

          <div className='card-title m-0 '>
            <h3 className='fw-bolder py-2'>{lastSeason?.title}</h3>
            <h3 className='fw-bolder ps-5'>{lastSeason ? `${moment(lastSeason.periodStart).format("YYYY MMM")} - ${moment(lastSeason.periodEnd).format("YYYY MMM")}` : ""}</h3>
          </div>

        </div>
        {/* begin::Body */}
        <div className='card-body py-3'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <TableStd
              tableSetting={tableSetting}
              toolbarSetting={toolbarSetting}
              columns={columnDef}
              footers={footerDef}
              data={data as []}
              dataFooter={footData as []}
            />
            {/* end::Table */}
          </div>

          {/* end::Table container */}
        </div>
        {/* begin::Body */}
      </div>
    </>
  )
}
export { SelfAssessPage }
